export const createKToast = (options = {}) => {
    const {
        wrapperId,
        toastMessage = 'Default toast message',
        icon = '<i class="k-icon-check-2"></i>',
        time = 2000,
        top = 0,
        zIndex = 6,
        bgColor = '#122448',
        padding = '15px 10px',
    } = options;

    let kToastWrapper = document.body;
    if (wrapperId) {
        kToastWrapper = document.querySelector(`#${wrapperId}`) 
    }

    if (kToastWrapper) {
        let toastzIndex = zIndex;
        let allKToastAlert = kToastWrapper.querySelectorAll('.k-toast-alert');

        if (allKToastAlert) {
           let totalToasts = allKToastAlert.length;
           toastzIndex = toastzIndex + totalToasts;
        }

        kToastWrapper.insertAdjacentHTML('afterBegin',
        `
            <div class="k-toast-alert" role="alert" style="z-index: ${toastzIndex}; margin-top: ${top}px; background-color: ${bgColor}; padding: ${padding}">
                <div class="k-toast-alert-content">
                    ${icon}
                    <p class="k-content">${toastMessage}</p>
                </div>
            </div>
        `);

        let currentKToast = kToastWrapper.querySelector('.k-toast-alert')

        if (currentKToast) {
            setTimeout(() => {
                if (currentKToast.parentNode) {
                    currentKToast.parentNode.removeChild(currentKToast);
                }
            }, time);
        }
    } else {
        alert('K-Toast: No wrapper detected');
    }
}